import BaseModelComponent from '../../../../base/base_model_component';
import _ from '../../../../utils/underscore';


class StripeComponentModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'StripeComponentModel';


    /**
     *
     * @param params
     */
    init(params = {}) {
        this._setShowClock(params.showClock)
    }


    /**
     *
     * @param showClock
     * @returns {StripeComponentModel}
     * @private
     */
    _setShowClock(showClock = true) {
        if (!_.isBoolean(showClock)) {
            this._showClock = true;
            return this;
        }

        this._showClock = showClock;
        return this;
    }


    /**
     *
     * @returns {boolean|*}
     */
    getShowClock() {
        return this._showClock;
    }
}
export default StripeComponentModel;